<div class="box">

  @if (pet.type === 'dog') {
    <img src="assets/bilder/anderes/grab-buddy.webp" alt="Buddys Grabstein">
  }
  @if (pet.type === 'cat') {
    <img src="assets/bilder/anderes/grab-kitty.webp" alt="Kittys Grabstein">
  }

  <app-button (click)="newTry()">😢 <br> Neues Tier adoptieren</app-button>

</div>
